import { Box } from "@itandi/itandi-bb-ui/Box";
import { Th } from "@itandi/itandi-bb-ui/Th";
import { Tr } from "@itandi/itandi-bb-ui/Tr";

import type { DealSortKey } from "~/models/Deal";

type Props = {
	handleSort: (selectedSortKey: DealSortKey) => () => Promise<void>;
	sortCondition: (sortKey: DealSortKey) => "asc" | "desc" | "none";
};

export function DealTableSPHeader({ sortCondition, handleSort }: Props) {
	return (
		<Tr>
			<Th
				onSort={handleSort("status_id")}
				sort={sortCondition("status_id")}
				width="7.5rem"
			>
				<Box marginY={8}>状況</Box>
			</Th>
			<Th>
				<Box marginY={8}>案件</Box>
			</Th>
		</Tr>
	);
}
